import React from "react";
import { TextField } from "@mui/material";

const MemoTextField = React.memo(
  ({
    name,
    label,
    value,
    error,
    helperText,
    onChange,
    onBlur,
    disabled,
    inputRef,
    fullWidth = true,
    ...props
  }) => {
    return (
      <TextField
        ref={inputRef}
        fullWidth={fullWidth}
        name={name}
        label={label}
        value={value || ""}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        error={Boolean(error)}
        helperText={helperText}
        {...props}
      />
    );
  }
);

export default MemoTextField;
